import { ModelBase } from '../../shared/base/model-base';

export class CurriculumUnit extends ModelBase {
  title?: string;
  date?: string;
  content?: string;
}




// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/shared/curriculum-unit.ts